import { Injectable } from '@angular/core';
import { combineLatestWith } from 'rxjs';
import { map } from 'rxjs/operators';
import { ManagementStoreService } from './management-store.service';
import {Locale} from '@emm/core/models/locale.model';
import {Screen} from '@emm/core/models/screen.model';


@Injectable({ providedIn: 'root' })
export class ManagementFacadeService {

    isLoading$ = this.managementStore.anyLoading$;
    screens$ = this.managementStore.queryBase.screens$;
    selectedScreen$ = this.managementStore.queryBase.selectedScreen$;
    isChainMenu$ = this.managementStore.queryLocationSets.isChainMenu$;
    isLocationSetTypeParent$ = this.managementStore.queryLocationSetTypes.isLocationSetTypeParent$;
    locationSets$ = this.managementStore.queryLocationSets.filteredLocationSets$;
    locationSetTypes$ = this.managementStore.queryLocationSetTypes.onlyParents$;
    selectedLocationSetType$ = this.managementStore.queryLocationSetTypes.selected$;


    parentLocationSets$ = this.isLocationSetTypeParent$.pipe(
        combineLatestWith(this.locationSets$),
        map(([isLocationSetTypeParent, locationSets]) =>
            isLocationSetTypeParent ? locationSets : null
        )
    );

    childLocationSets$ = this.managementStore.queryLocationSets.childLocationSets$;

    selectedLocationSet$ = this.managementStore.queryLocationSets.selected$;


    constructor(private managementStore: ManagementStoreService) {}



    init(): void {
        this.managementStore.dispatch.init();
    }



    changeScreen(screen: Screen): void {
        this.managementStore.dispatch.changeScreen(screen);
    }



    selectCountry(country: Locale): void {
        this.managementStore.dispatch.selectCountry(country);
    }


    applyLocationSetFilter(filter: string): void {
        this.managementStore.dispatch.updateFilter(filter);
    }

    selectLocationSetType(tag: string): void {
        this.managementStore.dispatch.selectLocationSetType(tag);
        this.managementStore.dispatch.loadChildLocations(tag);
    }

    selectLocationSet(tag: string): void {
        this.managementStore.dispatch.selectLocationSet(tag, null);
    }

    selectParentLocationSet(tag: string): void {
        this.managementStore.dispatch.selectLocationSet(tag, null);
        this.managementStore.dispatch.loadLocationsByParent(tag);
    }
}
